module.exports = __webpack_public_path__ + "static/media/che5.d799e463.png";